import React, { useState, useId, useEffect } from "react";
import { Container, Box, Typography, Grid, TextField, Button } from "@mui/material";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";

import { Link, useNavigate } from "react-router-dom";
import "./Cart.css";
import cat1 from "./../assests/deal2.png";
import cat2 from "./../assests/deal3.png";
import cat3 from "./../assests/bestD2.png";
import { FiMinus, FiPlus } from "react-icons/fi";
import { useCartStore } from "../store/useCartStore";
import Loader from "../components/Loader/Loader";

const cartItems = {

  marginBottom: "25px",
}




const Cart = () => {
  const id = useId();
  const products = [
    { image: cat1, name: "Latex Examination Gloves", discount: "-30%" },
    { image: cat2, name: "Latex Examination Gloves2", discount: "-30%" },
    { image: cat3, name: "Latex Examination Gloves 3", discount: "-30%" },
  ];

  // Add quantity 
  const [number, setNumber] = useState(1);
  const navigate = useNavigate()
  const { cart, total, getCart, updateQuantity, loading } = useCartStore()
  const updateQuantityFunction = async (id, value) => {
    await updateQuantity(id, value)
  };

  const getCartItemFunction = async () => {
    await getCart()
  }

  const handleNavigate = () => {
    navigate('/checkout', { state: { throughCart: true } });
  }

  useEffect(() => {
    getCartItemFunction()
  }, [])


  return (
    <>
      <Container>
        <Loader loading={loading} />
        <Grid
          container
          sx={{
            width: "100%",
            margin: {
              xs: "30px 0",
              sm: "40px 0",
              md: "50px 0",
              lg: "70px 0",
            },
          }}
          columnSpacing={{ xs: 1, sm: 2, md: 4 }}
        > <Grid item size={{ xs: 12, sm: 12, md: 8 }}>
            <Box
              sx={{
                // backgroundColor: "rgba(217, 217, 217, 0.4)",
                padding: "10px",
              }}
            >
              <Typography sx={{
                fontSize: '30px',
                lineHeight: '28.8px',
                fontWeight: '700',
                fontFamily: `"Quicksand", sans-serif`,
                color: '#253D4E',
                paddingBottom: '16px',
                borderBottom: '1px solid #00000024',
                margin: "0     0 30px",
                position: 'relative',
                '&::before': {
                  content: `""`,
                  width: '80px',
                  height: '2px',
                  background: '#008BFF',
                  position: 'absolute',
                  left: '0',
                  bottom: '0',
                },
              }}>  Your Cart</Typography>

              <TableContainer component={Paper} sx={{ boxShadow: "none", width: "100%",border: '1px solid #ccc', }}>
                <Table sx={{ width: "100%" }}>
                  <TableHead>
                    <TableRow>
                      <TableCell><b>Item</b></TableCell>
                      <TableCell><b>Details</b></TableCell>
                      <TableCell align="center"><b>Quantity</b></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {(cart || []).map((product, id) => (
                      <TableRow key={id}>
                        {/* Image Column */}
                        <TableCell>
                          <Box
                            sx={{
                              backgroundColor: "rgba(217, 217, 217, 0.4)",
                              border: "1px solid #2D3C67",
                              padding: "10px",
                              height: "100px",
                              width: "100px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              borderRadius: "4px",

                            }}
                          >
                            {product.images?.[0] ? (
                              <img
                                src={product.images[0]}
                                alt={product.name || "Product Image"}
                                style={{ maxWidth: "100%", maxHeight: "100%" }}
                              />
                            ) : (
                              <Typography>No Image</Typography>
                            )}
                          </Box>
                        </TableCell>

                        {/* Details Column */}
                        <TableCell>
                          <Typography
                            sx={{
                              fontFamily: `"Poppins", sans-serif`,
                              fontWeight: 600,
                              fontSize: "16px",
                              lineHeight: "20px",
                              color: "#3C3C3C",
                              "& span": {
                                display: "block",
                              },
                              "& span.subtext": {
                                fontWeight: 400,
                                color: "rgba(60, 60, 60, 0.79)",
                                margin: "4px 0",
                              },
                              "& span.price": {
                                color: "#2B3463",
                              },
                            }}
                          >
                            {product.name}
                            {product?.quantity !== undefined && (
                              <span className="subtext">{`Unit ${product.quantity}`}</span>
                            )}
                            {product?.color && (
                              <span className="subtext">{`Color: ${product.color}`}</span>
                            )}
                            {product?.selectedSize && (
                              <span className="subtext">{`Size: ${product.selectedSize}`}</span>
                            )}
                            {product?.weight && (
                              <span className="subtext">{`Weight: ${product.weight}`}</span>
                            )}
                            {product?.total && (
                              <span className="price">{`$${product.total}`}</span>
                            )}
                          </Typography>
                        </TableCell>

                        {/* Quantity Controls */}
                        <TableCell align="center">
                          <Box className="counter cartQuantity" sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "10px" }}>
                            <button
                              className="buttonDectoCart"
                              onClick={() => updateQuantityFunction(product._id, -1)}
                            >
                              <FiMinus />
                            </button>
                            <p className="textAddtoCart">{product?.quantity}</p>
                            <button
                              className="buttonAddtoCart"
                              onClick={() => updateQuantityFunction(product._id, 1)}
                            >
                              <FiPlus />
                            </button>
                          </Box>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </Grid>

          <Grid item size={{ xs: 12, sm: 12, md: 4 }}>
            <Box
              sx={{
                backgroundColor: "rgb(245, 245, 245)",
                padding: "30px 20px",
                margin: "60px 0 30px",
                borderRadius: "4px",
              }}>
              <Typography
                variant="h2"
                sx={{
                  fontFamily: `"Quicksand", sans-serif`,
                  fontWeight: 700,
                  fontSize: "20px",
                  lineHeight: "30.76px",
                  color: "#3C3C3C",
                  textAlign: "left",
                }}
              >
                Order Summary
              </Typography>
              <ul className="cartDetail">
                <li>
                  <span>subtotal</span>
                  <span>{`$${total}`}</span>
                </li>
                <li>
                  <span>discount </span>
                  <span>$ 0.00</span>
                </li>
                <li>
                  <span>VAT (5%)</span>
                  <span>$ 16.50</span>
                </li>
                <li>
                  <span>
                    <b>Total</b>
                  </span>
                  <span>
                    <b>{`$${total}`}</b>
                  </span>
                </li>
              </ul>
              <Button
                variant="contained"
                onClick={handleNavigate}
                sx={{
                  width: "100%",
                  height: "46px",
                  borderRadius: "0px",
                  backgroundColor: "#2D3C67",
                  color: "#fff",
                  fontSize: "16px",
                  lineHeight: "24px",
                  letterSpacing: "0.5px",
                  fontWeight: "600",
                  fontFamily: `"Quicksand", sans-serif`,
                  textTransform: "capitalize",
                  "& a": {
                    color: "#fff",
                  },
                }}
              >
                Continue to checkout
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default Cart;
